import React from 'react';
import { Hero } from '../components/Hero';
import { PainPoint } from '../components/PainPoint';
import { Services } from '../components/Services';
import { WhyChooseUs } from '../components/WhyChooseUs';
import { Testimonials } from '../components/Testimonials';
import { CTASection } from '../components/CTASection';
export function Home() {
  return <>
      <Hero data-id="element-327" data-mp="2x7slkucsfju5" />
      <PainPoint data-id="element-328" data-mp="1zhxkqdjnmqzd" />
      <Services data-id="element-329" data-mp="1zih29t5e7dcv" />
      <WhyChooseUs data-id="element-330" data-mp="1ziz8nilrr7yi" />
      <Testimonials data-id="element-331" data-mp="1zjig25dsmdya" />
      <CTASection data-id="element-332" data-mp="1zk20bsqx1efh" />
    </>;
}